import { NavBar, Form, Button, Input, Toast, Selector, DatePicker } from 'antd-mobile'
import React, { useEffect, useState } from 'react'
import '../../styles/pages/dinner-form.css'
import './index.css'
import { useLocation } from 'react-router-dom'
import { DINNER_PAY_OPTIONS } from '../dinnerStatus';
import { dinnerApi } from '../../features/dinner/api/dinnerApi';
import { matchApi } from '../../features/match/api/matchApi';

const formatDate = (date) => {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export default function CreateDinner() {

    const location = useLocation();
    const gameId = location.state?.gameId;
    const archiveOnly = location.state?.archiveOnly;
    const [buttomLoading, setButtomLoading] = useState(false)
    const [gameDetail, setGameDetail] = useState(null)
    const [datePickerVisible, setDatePickerVisible] = useState(false);
    const [selectedDinnerDate, setSelectedDinnerDate] = useState(formatDate(new Date()));

    useEffect(() => {
        if (!gameId) return;
        matchApi.getDetail(gameId).then((response) => {
            const detail = response.data?.data || null;
            setGameDetail(detail);
            const matchDate = detail?.matchTime?.slice?.(0, 10) || detail?.startDate || '';
            if (matchDate) setSelectedDinnerDate(matchDate);
        });
    }, [gameId]);

    const defaultDinnerDate = gameDetail?.matchTime?.slice?.(0, 10) || gameDetail?.startDate || selectedDinnerDate;

    const createGamefunc = (values) => {
        Toast.show({
            icon: 'loading',
            duration: 0,
        })
        setButtomLoading(true)

        dinnerApi.create({
            // 独立存档聚餐不绑定比赛；比赛详情发起时才传 gameId。
            gameId: gameId || '',
            position: values.position,
            remark: values.gameRemark,
            lat: 0,
            lng: 0,
            status: values.status[0],
            // 聚餐列表直接创建时允许管理员手动选择日期，用于补录存档。
            dinnerDate: selectedDinnerDate || defaultDinnerDate
        })
            .then(function (response) {
                if (response.data.code === 200) {
                    Toast.show({
                        content: '创建成功！',
                        icon: 'success',
                        afterClose: () => {
                            window.history.back();
                        },
                    })
                } else {
                    Toast.show({
                        content: response.data.msg,
                        icon: 'fail'
                    })
                }
            })
            .catch(function () {
                Toast.show({
                    content: '创建失败,请重试!',
                    icon: 'fail'
                })
            })
            .finally(() => {
                setButtomLoading(false)
            });
    }

    return (
        <div className="dinner-form-scope dinner-form-container has-unified-nav">
            <NavBar className="unified-navbar fixed" onBack={() => window.history.back()}>
                发起聚餐活动
            </NavBar>

            <div className="glass-form-card">
                <div className="form-header-premium">
                    <span className="form-header-icon">🍽️</span>
                    <span className="form-header-title">{archiveOnly ? '聚餐存档' : '聚餐计划'}</span>
                </div>
                {archiveOnly && (
                    <div className="dinner-archive-tip">
                        这条聚餐记录不会绑定比赛或喜事，只用于球队聚餐资料归档。
                    </div>
                )}

                <Form
                    className="dinner-form-premium"
                    name='form'
                    onFinish={(values) => createGamefunc(values)}
                    initialValues={{
                        status: [1],
                    }}
                    footer={
                        <div className="form-footer-premium">
                            <Button
                                block
                                type='submit'
                                className="submit-btn-premium"
                                loading={buttomLoading}
                            >
                                确认发起活动
                            </Button>
                        </div>
                    }
                >
                    <Form.Item name='position' label='📍 聚餐地点' rules={[{ required: true, message: '请填写地点' }]}>
                        <Input placeholder='输入餐厅或地点名称...' />
                    </Form.Item>

                    <Form.Item name='gameRemark' label='📝 备注信息' >
                        <Input placeholder='备注聚餐详情（可选）...' />
                    </Form.Item>

                    <Form.Item label='📅 聚餐时间'>
                        <button type="button" className="dinner-form-date-preview dinner-form-date-button" onClick={() => setDatePickerVisible(true)}>
                            {selectedDinnerDate || defaultDinnerDate || '请选择聚餐日期'}
                        </button>
                    </Form.Item>

                    <Form.Item name='status' label='💰 支付方式' >
                        <Selector
                            columns={2}
                            options={DINNER_PAY_OPTIONS}
                        />
                    </Form.Item>
                </Form>
            </div>
            <DatePicker
                title="选择聚餐日期"
                precision="day"
                visible={datePickerVisible}
                value={new Date(`${selectedDinnerDate || formatDate(new Date())} 00:00:00`)}
                onClose={() => setDatePickerVisible(false)}
                onConfirm={(value) => setSelectedDinnerDate(formatDate(value))}
            />
        </div >
    )
}
